export const Config = {
  //public backend:string = '/cms';
  backend : 'http://95.217.154.68/cms'
};